import React from 'react';
import { motion } from 'framer-motion';

export interface StatBoxProps {
  children: React.ReactNode;
  index?: number;
  staggerDelay?: number;
}

const containerVariants = {
  hidden: { opacity: 0, y: 24 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      delay: i,
      ease: [0.25, 0.46, 0.45, 0.94] as const,
    },
  }),
};

export const StatBox = React.forwardRef<HTMLDivElement, StatBoxProps>(function StatBox(
  { children, index = 0, staggerDelay = 0 },
  ref,
) {
  return (
    <motion.div
      ref={ref}
      className="about-stat-box"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      custom={staggerDelay + index * 0.1}
    >
      {children}
    </motion.div>
  );
});
